module.exports = __webpack_public_path__ + "img/showers-no.14751156.svg";